import React from 'react';
import Drawer from 'Components/Drawer';
import NoSSR from 'Components/NoSSR';
import { useDispatch, useSelector } from 'react-redux';
import Icon from 'Components/Icon';
import { closeDrawer } from 'Store/actions';

const defaultPositionProps = { web: 'right', mobile: 'bottom' };

const DrawerWrapper = () => {
  const dispatch = useDispatch();
  const drawer = useSelector(state => state.drawer);
  const userAgent = useSelector(state => state.userAgent);
  const drawerPosition = { ...defaultPositionProps, ...drawer.position };
  

  return (
    <NoSSR>
      <Drawer
        title={ drawer?.title }
        type={ drawer?.type }
        className={ drawer?.className }
        showCloseOnBottom={ drawer?.showCloseOnBottom }
        buttonArea={ drawer?.buttonArea }
        open={ drawer?.isOpen || false }
        anchor={ drawer?.anchor }
        container={ drawer?.container }
        icon={ drawer?.iconName ? <Icon className="modal__container__icon" iconName={ drawer.iconName } /> : undefined }
        position={ userAgent.device?.type === 'desktop' ? drawerPosition.web : drawerPosition.mobile }
        onClose={ () => {
          dispatch(closeDrawer());
          drawer?.onClose && drawer?.onClose();
        } }
      >
        { drawer?.content }
      </Drawer>
    </NoSSR>
  );
};

export default DrawerWrapper;
